import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var UndoIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M22.4 8.667c-.9-2.5-2.7-4.5-5.1-5.7-2.4-1.1-5.1-1.3-7.7-.4-1.3.5-2.5 1.2-3.7 2.3L3 7.667v-3.7c0-.6-.4-1-1-1s-1 .4-1 1v6.3c0 .1.1.1.1.2 0 0 0 .1.1.1l.2.2s.1 0 .1.1h.1c.2.1.3.1.4.1h6c.6 0 1-.4 1-1s-.4-1-1-1H4.5l2.8-2.7c.9-.8 2-1.5 3.1-1.9 2-.7 4.2-.6 6.2.3 1.9.9 3.4 2.5 4.1 4.5 1.4 4.2-.7 8.7-4.9 10.2-4.3 1.6-8.8-.6-10.4-4.7-.2-.5-.8-.8-1.3-.6-.5.2-.8.8-.6 1.3 1.5 4.1 5.4 6.6 9.5 6.6 1.1 0 2.2-.2 3.3-.6 5.3-1.8 7.9-7.5 6.1-12.7z"
                        }),
                        _jsxs("g", {
                            fillRule: "evenodd",
                            children: [
                                _jsx("use", {}),
                                _jsx("use", {
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
UndoIcon.isCarinaIcon = true;
export default UndoIcon;
